'use client';

import React, { useState } from 'react';
import { Bell } from 'lucide-react';
import { useTheme } from '@/core/providers/ThemeProvider';

const UsageAlerts: React.FC = () => {
  const { theme } = useTheme();
  const [highUsageAlert, setHighUsageAlert] = useState(true);
  const [monthlyReport, setMonthlyReport] = useState(true);
  const [deliveryFailureAlert, setDeliveryFailureAlert] = useState(true);

  return (
    <div className="rounded-lg border p-4" style={{
      borderColor: theme.border,
      backgroundColor: theme.cardBackground,
      borderStyle: 'dashed'
    }}>
      <div className="flex items-center mb-3">
        <Bell className="h-4 w-4 mr-2" style={{ color: theme.textSecondary }} />
        <h3 className="text-sm font-medium" style={{ color: theme.textPrimary }}>Alert Preferences</h3>
      </div>

      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <div>
            <div className="text-sm" style={{ color: theme.textPrimary }}>High usage warning</div>
            <div className="text-xs" style={{ color: theme.textSecondary }}>Alert at 80% of limit</div>
          </div>
          <button
            onClick={() => setHighUsageAlert(!highUsageAlert)}
            className="relative inline-flex h-6 w-11 items-center flex-shrink-0 cursor-pointer rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
            style={{ backgroundColor: highUsageAlert ? theme.primary : 'var(--color-text-tertiary)' }}
            role="switch"
            aria-checked={highUsageAlert}
          >
            <span
              className={`pointer-events-none absolute inset-y-0.5 h-5 w-5 rounded-full bg-white shadow-md ring-0 transition-transform duration-200 ease-in-out ${
                highUsageAlert ? 'left-[1.375rem]' : 'left-0.5'
              }`}
            />
          </button>
        </div>

        <div className="flex items-center justify-between">
          <div>
            <div className="text-sm" style={{ color: theme.textPrimary }}>Monthly report</div>
            <div className="text-xs" style={{ color: theme.textSecondary }}>Email summary</div>
          </div>
          <button
            onClick={() => setMonthlyReport(!monthlyReport)}
            className="relative inline-flex h-6 w-11 items-center flex-shrink-0 cursor-pointer rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
            style={{ backgroundColor: monthlyReport ? theme.primary : 'var(--color-text-tertiary)' }}
            role="switch"
            aria-checked={monthlyReport}
          >
            <span
              className={`pointer-events-none absolute inset-y-0.5 h-5 w-5 rounded-full bg-white shadow-md ring-0 transition-transform duration-200 ease-in-out ${
                monthlyReport ? 'left-[1.375rem]' : 'left-0.5'
              }`}
            />
          </button>
        </div>

        <div className="flex items-center justify-between">
          <div>
            <div className="text-sm" style={{ color: theme.textPrimary }}>Delivery failures</div>
            <div className="text-xs" style={{ color: theme.textSecondary }}>Instant notifications</div>
          </div>
          <button
            onClick={() => setDeliveryFailureAlert(!deliveryFailureAlert)}
            className="relative inline-flex h-6 w-11 items-center flex-shrink-0 cursor-pointer rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
            style={{ backgroundColor: deliveryFailureAlert ? theme.primary : 'var(--color-text-tertiary)' }}
            role="switch"
            aria-checked={deliveryFailureAlert}
          >
            <span
              className={`pointer-events-none absolute inset-y-0.5 h-5 w-5 rounded-full bg-white shadow-md ring-0 transition-transform duration-200 ease-in-out ${
                deliveryFailureAlert ? 'left-[1.375rem]' : 'left-0.5'
              }`}
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default UsageAlerts; 